import React from 'react';
import {useTranslation} from 'react-i18next';
import {Box, Table, Thead, Tbody, Tr, Td} from '@chakra-ui/react';
import TableRow from './TableRow';

const ResultTable = ({result}) => {
  const {t} = useTranslation();

  return (
      <Box>
        <Table className="table table-striped table-borderless">
          <Thead>
            <Tr>
              <Td>
                <Box pl={4}>
                  <strong>
                    {t('machineType')}
                  </strong>
                  <br/>
                  {result && result.machineSerialNumber !== null ? result.machineType : <br/>}
                </Box>
              </Td>
              <Td>
                <Box>
                  <strong>
                    {t('machineSerialNumber')}
                  </strong>
                  <br/>
                  {result && result.machineSerialNumber !== null ? result.machineSerialNumber : <br/>}
                </Box>
              </Td>
            </Tr>
          </Thead>
          <Tbody>
            {result && result.machineSerialNumber !== null ? (
                result.machineDocuments && result.machineDocuments.length > 0 ? (
                    result.machineDocuments.map((document, index) => (
                        <TableRow key={index}>
                          <a className="link link--standalone link--icon"
                             href={document.mediaurl}
                             download
                             target="_blank"
                             rel="noopener noreferrer">
                            <i className="pm-icon-file text--putzmeister-yellow"/> {document.displayName}
                          </a>
                        </TableRow>
                    ))
                ) : (
                    <TableRow>
                      {t('noDocuments')}
                    </TableRow>
                )
            ) : (
                <TableRow>
                  {t('noResult')}
                </TableRow>
            )}
          </Tbody>
        </Table>
      </Box>
  );
}

export default ResultTable;